import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {
  public DISPLAYINLINEBLOCKIMPORTANT: string = 'display:inline-block !important; zoom: 1;';
  public CUSTOMIZATIONMOBILEREPOSITIONWIDGETCSS: string = 'display:inline-block!important; top:auto;right:5px;left:auto;bottom:155px;zoom: 1;';  
  public CUSTOMIZATIONMOBILESTANDARDCSS: string = 'display:inline-block!important; top:155px;right:5px;left:auto;bottom:auto;zoom:1;';
  public CHECKOUTMOBILEREPOSITIONWIDGETCSS: string = 'display:inline-block!important; top:45px;right:5px;left:auto;bottom:auto;zoom:1;';
  public MYORDERSUMMARYMOBILETOPRIGHTDOCK: string = 'display:inline-block!important; top:5px;right:20px;left:auto;bottom:auto;zoom:0.8';
  public SIGNINSIGNUPMODALPOSITION: string = 'display:inline-block!important; top:15px;left:15px;right: auto;bottom:auto;zoom:1;';
  public GUESTPAYMENTSCREENPOSITIONWIDGETCSS : string = 'display:inline-block!important; top:60px;right:5px;left:auto;bottom:auto;zoom:0.8;';
  public DISPLAYNONEIMPORTANT: string = 'display:none !important; zoom: 1;';
  public isChatOpen: any;
  constructor() { }
  public setAccessibilityWidgetCSSText(cssText: string, returnLastPosition = false): string {
    let lastPosition = '';
    var accessibilityWidget = document.getElementById(environment.USABLENET_WIDGET_ID);
    if(accessibilityWidget) {
      if(returnLastPosition) {
        lastPosition = (' ' + accessibilityWidget.style.cssText).slice(1); 
      }
      if (this.isChatOpen) {
        accessibilityWidget.style.cssText = this.DISPLAYNONEIMPORTANT;
      } else {
        accessibilityWidget.style.cssText = cssText;
      }
    }
    return lastPosition;    
  }
  public makeScreenReaderReadText(text: string, priority = null) {
    let el = document.createElement("span");
    let id = "speak-" + Date.now();
    el.setAttribute("id", id);
    el.setAttribute("aria-live", priority || "polite");
    el.classList.add("visually-hidden");
    document.body.appendChild(el);

    window.setTimeout(function () {
      document.getElementById(id).innerHTML = text;
      document.body.style.overflowY = 'hidden';
    }, 100);

    window.setTimeout(function () {
      document.getElementById(id).innerHTML = '';
      document.body.style.overflowY = '';
    }, 1000);
  }
}
